module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "calibre_4",
    attrs: {
      "id": "filepos6394"
    }
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("In Honor of Michel Eyquem de Montaigne")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_6"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("(1533 – 1592)")])]), _c('div', {
    staticClass: "calibre_13"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("“We are born to inquire after Truth”…it belongs to a greater power to possess it. It is not as Democritus said, hid in the bottom of the deeps, but rather elevated to an infinite height in the divine knowledge!")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_14"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("—Michel Eyquem de Montaigne")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_15"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nothing I See Means Anything")])])]), _c('div', {
    staticClass: "calibre_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("The reason this is so is that I see nothing, and nothing has no meaning. It is necessary that I recognize this that I may learn to see. What I think I see now is taking the place of vision. I must let it go by realizing it has no meaning, so that vision may take its place.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_14"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Course in Miracles")])])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2baadc4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_003.vue
// module id = 69
// module chunks = 0